import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntercomProvider } from 'react-use-intercom';
import store from 'redux/store';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntercomProvider appId='p4hz4ihv'>
        <App />
      </IntercomProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
